import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

//O comportamento de validação desta directiva pode ser obtido usango o min e maxLength em conjunto
//apenas foi customizado para que as mensagens de erro possam ser distintas

@Directive({
    selector: 'input[exactLength]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ExactLengthDirective, multi: true }],
    standalone: false
})
export class ExactLengthDirective implements Validator {
  @Input()
  exactLength: number;

  validate(c: FormControl): { [key: string]: any } {
    if (this.exactLength == 0) {
      return null;
    }
    return c.value?.toString().length != this.exactLength ? { 'exactLength': this.exactLength } : null;
  }
}
